<div class="container white z-depth-1 p-5" *ngIf="page">
	<h1 *ngIf="page.name_page" class="text-center">{{page.name_page}}</h1>
	<!-- <a class="icons-sm fb-ic" shareButton="facebook" #fbBtn ><mdb-icon fab icon="facebook-f"></mdb-icon></a> -->
	<div class="content ck-content" [innerHtml]="page.content | safeHtml" *ngIf="route.snapshot.params['id'] != '152'"></div>
	<a [routerLink]="['/preorders-essen']" title="Participer au jeu" *ngIf="route.snapshot.params['id'] == '152'">
		<div class="content ck-content" [innerHtml]="page.content | safeHtml" ></div>
	</a>
</div>

<div class="grid news " *ngIf="news">
	<h1 class="text-primary mx-2 uppercase col-12">LES NEWS</h1>
	<ng-container *ngFor="let item of news">
		<a [routerLink]="['/news/'+item.id_page]" class="p-2 sm:col-6 md:col-3 col-12" [innerHTML]="item.imgs[0]" *ngIf="item.from == 'admin' && item.imgs &&  item.imgs[0]"></a>
		<div *ngIf="item.from == 'wp'"  class="p-2 sm:col-6 md:col-3 col-12">
			<div class="surface-card h-full flex flex-column justify-content-between wpNews">

				<a [routerLink]="['/pages/'+item.slug]">
					<img [src]="item.img" />
				</a>
				<h2 class="text-center" [innerHTML]="item.title"></h2>


				<a [routerLink]="['/pages/'+item.slug]" class="mb-2 text-white text-right block">
					En savoir plus...
				</a>
			</div>
		</div>
	</ng-container>
</div>